import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

import { TAB_MENUS, MENU_3, OBJ_BG_COLORS } from '../constants'
import { lockOrder, getOrdersLocked, getOrdersByStatus } from '../Services/serviceAdmin'
import Colors from '../../../constants/Colors'

const Menu = ({ status, setStatus, fetchOrdersByStatus, updateAllState }) => {
  const fetchOrdersLocked = async () => {
    const allOrder = await getOrdersLocked()
    await updateAllState(allOrder)
  }

  const fetchOrdersIssue = async () => {
    const response = await getOrdersByStatus('CONFIRMED', true)
    const allIssue = response.filter((v) => v.isIssue)
    const selectedOrder = allIssue[0]

    if (selectedOrder?.status === 'CONFIRMED') {
      await lockOrder(selectedOrder?.id)
    }

    await updateAllState(allIssue)
  }

  const selectMenu3 = async (status) => {
    switch (status) {
      case 'LOCKED':
        await fetchOrdersLocked()
        break
      case 'ISSUE':
        await fetchOrdersIssue()
        break
      default:
    }
    setStatus(status)
  }

  const renderMenu1 = () => {
    return (
      <ButtonLink>
        <LotteryLink to="/order">ลอตเตอรี่</LotteryLink>
        <SlotLink to="/orderSlot">คูปอง</SlotLink>
      </ButtonLink>
    )
  }
  const renderStatusMenu = () => {
    return (
      <ButtonGroup>
        {Object.keys(TAB_MENUS).map((key) => {
          return (
            <Button
              key={key}
              color={OBJ_BG_COLORS[key]}
              actived={key === status}
              onClick={() => fetchOrdersByStatus(key)}
            >
              {TAB_MENUS[key]}
            </Button>
          )
        })}
      </ButtonGroup>
    )
  }

  const renderMenu3 = () => {
    return (
      <ButtonGroup className="w-25">
        {Object.keys(MENU_3).map((key) => {
          return (
            <Button key={key} color={OBJ_BG_COLORS[key]} actived={key === status} onClick={() => selectMenu3(key)}>
              {MENU_3[key]}
            </Button>
          )
        })}
        <SearchButton bgColor={status === 'SEARCH' && OBJ_BG_COLORS['SEARCH']}>ค้นหา</SearchButton>
      </ButtonGroup>
    )
  }

  return (
    <TabMenu>
      {renderMenu1()}
      {renderStatusMenu()}
      {renderMenu3()}
    </TabMenu>
  )
}

export default Menu

const TabMenu = styled.div`
  display: flex;
  gap: 20px;
`
const ButtonLink = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
`
const LotteryLink = styled(Link)`
  text-decoration: none;
  width: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${Colors.SOFT_BLUE};
  border: 1px solid ${Colors.SOFT_BLUE};
  &:hover {
    color: ${Colors.WHITE};
    border-color: ${Colors.LIGHT_RED};
    background-color: ${Colors.LIGHT_RED};
  }
`
const SlotLink = styled(Link)`
  text-decoration: none;
  width: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: default;
    color: ${Colors.WHITE};
  }
  color: ${Colors.WHITE};
  background-color: ${Colors.LIGHT_RED};
`
const ButtonGroup = styled.div`
  width: 100%;
  display: flex;
  gap: 1px;
  justify-content: space-between;
`
const Button = styled.div`
  padding: 20px 0;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  &:hover {
    cursor: pointer;
    box-shadow:
      rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset,
      rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;
    color: ${Colors.WHITE};
    background-color: ${({ color = Colors.ORANGE }) => color};
  }
  border: 1px solid ${({ color = Colors.ORANGE }) => color};
  color: ${Colors.BLACK};
  ${({ actived, color }) =>
    actived &&
    css`
      color: ${Colors.WHITE};
      background-color: ${color};
    `}
`
const SearchButton = styled.div`
  padding: 20px 0;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 1px solid ${Colors.DARK_GREY};
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ bgColor }) => bgColor && Colors.WHITE};
`
// ย่อ styled ของ menu ได้มากกว่านี้
